module.exports = __webpack_public_path__ + "static/img/live.b07d13f4.gif";